import { render, staticRenderFns } from "./ClientAddNewAddress.vue?vue&type=template&id=3ad97358&"
import script from "./ClientAddNewAddress.vue?vue&type=script&lang=js&"
export * from "./ClientAddNewAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports